import React, { useState, useEffect } from 'react';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import { motion } from 'framer-motion';
import { AppWrap, MotionWrap } from '../../wrapper';   //importing hoc this will also force component to take full space of screen
import './Work.scss';

import { urlFor, client } from '../../client';  //importing backend connection files

const Work = () => {
  const [activeFilter, setActiveFilter] = useState('All');  //creating a state initially = showing all
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);
  const [tags, setTags] = useState([]);

  const handleWorkFilter = (item) => {  //creating a function to handle filter toggle
    setActiveFilter(item);
    setAnimateCard({ y: 100, opacity: 0 });
    setTimeout(() => {
      setAnimateCard({ y: 0, opacity: 1 }); //its gonaa re-trigger the suffle animation of card once toggle is updated (above and this command)
      if (item === "All") {
        setFilterWork(works);
      }
      else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));  //filtering depending upon selected toggle
      }
    }, 500);
  }

  useEffect(() => {  //requesting data from backend
    const query = '*[_type == "works"]';  //for fetching work section from backend
    client.fetch(query).then((data) => { setWorks(data); setFilterWork(data); })  //will return a promise

    const tagsQuery = '*[_type == "works"].tags[]';
    client.fetch(tagsQuery).then((loadedTags) => {
      const uniqueTags = [...new Set(loadedTags.flat())];
      uniqueTags.sort((a, b) => a === 'All' ? 1 : b === 'All' ? -1 : a.localeCompare(b));
      setTags(uniqueTags);
    });
  }, []);

  return (
    <div>
      <h2 className="head-text white-head">
        My Creative <span>Projects</span> Section
      </h2>
      <div className="app__work-filter">
        {tags.map((item, index) => (
          <div key={index} onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item app__flex p-text ${activeFilter === item ? 'item-active' : ''}`}>
            {item}
          </div>
        ))}
      </div>
      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__work-portfolio'>
        {filterWork.map((work, index) => (  //for each returning a div
          <div className="app__work-item app__flex" key={index}>
            <div className="app__work-img app__flex">
              <img src={urlFor(work.imgUrl)} alt={work.name} />
              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5 }}
                className='app__work-hover app__flex'>
                <a href={work.projectLink} target="_blank" rel='noreferrer'>
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className='app__flex'>
                    <AiFillEye />  {/*adding our icon */}
                  </motion.div>
                </a>
                <a href={work.codeLink} target="_blank" rel='noreferrer'>
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className='app__flex'>
                    <AiFillGithub />  {/*adding our icon */}
                  </motion.div>
                </a>
              </motion.div>
            </div>
            <div className="app__work-content app__flex">
              <h4 className="bold-text">{work.title}</h4>
              <p className="p-text" style={{ marginTop: 10 }}>
                {work.description.length > 150 ? 
                  `${work.description.substring(0, 150)}...` 
                : 
                  work.description
                }
              </p>
              <div className="app__work-tag app__flex">
                <p className="p-text">{work.tags[0]}</p>  {/*rendering first tag in the list */}
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </div>
  )
}

export default AppWrap(
  MotionWrap(Work, 'app__works'),
  'work',
  'app__primarybg'
);  //using HOC and setting work, first wrapping in Addwrap and then wrapping the main comp in motionwrap
